import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { DuplicatedProjectPayload } from '@/api/v4/projects.api';
import { duplicateProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';

import { useTranslation } from 'react-i18next';
import { notify } from '@/ui/snackbar/notify';

export const useDuplicateProject = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('default');

  const mutation = useMutation({
    mutationFn: (payload: DuplicatedProjectPayload) =>
      duplicateProject(payload),
    onError: () => {
      notify({ message: t`unknownError` });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectsKpi] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.Projects] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectOptions] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  return {
    duplicateProject: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
